<template>
  <van-popup v-model="visible" position="bottom" round closeable :style="{ maxHeight: '90%' }" @closed="reset">
    <div class="sheet">
      <div class="sheet-title">✨ 意外發現</div>

      <div v-if="step === 1" class="form-area">
        <div class="auto-meta">
          <span class="tag-chip">🕒 {{ nowLabel }}</span>
          <span class="tag-chip">📍 {{ location.label }}</span>
        </div>
        <input type="file" accept="image/*" @change="onFile" class="file-input">
        <div v-if="photoPreview" class="photo-preview"><img :src="photoPreview" alt="preview"></div>
        <van-field v-model="text" type="textarea" rows="2" placeholder="寫一句話（選填），例如「這間中古店超正」" />
        <div class="actions">
          <van-button block type="primary" @click="step = 2">下一步</van-button>
        </div>
      </div>

      <div v-else-if="step === 2" class="form-area">
        <p class="question">有進去嗎？</p>
        <div class="status-grid">
          <button type="button" class="status-btn" @click="chooseStatus('visited')">
            <span class="icon">✅</span>進去了
          </button>
          <button type="button" class="status-btn" @click="chooseStatus('missed')">
            <span class="icon">🙈</span>沒進去
          </button>
          <button type="button" class="status-btn" @click="chooseStatus('planned')">
            <span class="icon">📌</span>之後再來
          </button>
        </div>
      </div>

      <div v-else-if="step === 3" class="form-area">
        <p class="question">附近可能是：</p>
        <van-cell
          v-for="p in nearby" :key="p.placeId"
          :title="p.name" :label="p.address" clickable
          @click="confirmMatch(p)"
        >
          <template #right-icon><van-icon name="arrow" /></template>
        </van-cell>
        <van-cell title="都不是，保留為未命名地點" clickable @click="confirmMatch(null)" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import { Toast } from 'vant'
import { getMockLocation } from '@/utils/geo'
import { nearbyMockPlaces } from '@/utils/mockPlaces'

export default {
  name: 'DiscoveryFlow',
  props: {
    tripId: { type: String, required: true },
    creatorId: { type: String, required: true }
  },
  data () {
    return {
      visible: false,
      step: 1,
      text: '',
      photoPreview: null,
      location: getMockLocation(),
      status: 'visited',
      nearby: []
    }
  },
  computed: {
    nowLabel () {
      return dayjs().format('MM/DD HH:mm')
    }
  },
  methods: {
    ...mapActions({
      addDiscoveredPoint: 'points/addDiscoveredPoint',
      createMoment: 'moments/createMoment',
      queueForSync: 'ui/queueForSync'
    }),
    open () {
      this.visible = true
      this.location = getMockLocation()
    },
    onFile (e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = () => { this.photoPreview = reader.result }
      reader.readAsDataURL(file)
    },
    chooseStatus (status) {
      this.status = status
      this.nearby = nearbyMockPlaces(this.location.lat, this.location.lng, 3)
      this.step = 3
    },
    confirmMatch (place) {
      const pointId = this.addDiscoveredPoint({
        tripId: this.tripId,
        place,
        memberId: this.creatorId,
        status: this.status
      })
      this.createMoment({
        tripId: this.tripId,
        creatorId: this.creatorId,
        kind: 'discovery',
        text: this.text,
        media: this.photoPreview ? [this.photoPreview] : [],
        pointId,
        location: { lat: this.location.lat, lng: this.location.lng, label: place ? place.name : this.location.label },
        visibility: 'trip'
      })
      this.queueForSync('新增意外發現')
      Toast.success('已記錄這個意外發現！')
      this.visible = false
      this.$emit('created', pointId)
    },
    reset () {
      this.step = 1
      this.text = ''
      this.photoPreview = null
      this.status = 'visited'
      this.nearby = []
    }
  }
}
</script>

<style scoped>
.sheet { padding-bottom: 16px; }
.sheet-title { padding: 16px; font-weight: 700; font-size: 16px; border-bottom: 1px solid var(--color-border); }
.form-area { padding: 14px 0; }
.auto-meta { display: flex; gap: 8px; padding: 0 16px 10px; }
.file-input { margin: 0 16px 10px; display: block; }
.photo-preview { margin: 0 16px 10px; }
.photo-preview img { max-width: 100%; border-radius: var(--radius-md); max-height: 180px; object-fit: cover; }
.actions { padding: 16px; }
.question { padding: 0 16px; font-weight: 600; }
.status-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; padding: 12px 16px; }
.status-btn {
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  padding: 16px 4px; border-radius: var(--radius-md); border: 1px solid var(--color-border); background: #fff; font-size: 12px;
}
.icon { font-size: 22px; }
</style>
